import { render, staticRenderFns } from "./PatentCard.vue?vue&type=template&id=79aead40&"
import script from "./PatentCard.vue?vue&type=script&lang=js&"
export * from "./PatentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports